import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import React from 'react';
import { Middleware, MiddlewareAdmin } from './Middleware';
import { TokenValidateExpiration } from './Token';
import { useParams } from 'react-router-dom';

const token = localStorage.getItem("token");

function ProviderDocumentView(id) {
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/document/read/' + id  + '/' + token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        let pdfWindow = window.open("")
        pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(response.data.message) + "'></iframe>"
        )
    });
}

function AdminProviderBankAccountCertPetition(id, provider, rfc) {
    window.scrollTo(0, 0);
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("ChgB").style.display = "block";

    const token = localStorage.getItem("token");
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/certificate/init/' + id+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "La cuenta bancaria ha iniciado su proceso de certificación, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/administrador-proveedor-revision/'+provider+'/'+rfc;
        }, 3000);
    });
}

function AdminProviderAccept(id) {
    var ccb = document.getElementById("ccb").value;
    if (ccb != 5) {
        document.getElementById('ccb').scrollIntoView();
        alert("La cuenta bancaria debe ser certificada para aceptar el proveedor");
        return;
    }

    const token = localStorage.getItem("token");
    document.getElementById("Chg").style.display = "block";
    document.getElementById("BtnA").style.display = "none";
    document.getElementById("BtnB").style.display = "none";
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/accept/' + id+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.location.href = '/administrador';
    }
)
.catch(error => {
    document.getElementById("Chg").style.display = "none";
    document.getElementById("BtnA").style.display = "inline-block";
    document.getElementById("BtnB").style.display = "inline-block";
})
;
}

function AdminProviderDecline(provider, rfc) {
    const token = localStorage.getItem("token");
    document.getElementById("Chg").style.display = "block";
    document.getElementById("BtnA").style.display = "none";
    document.getElementById("BtnB").style.display = "none";

    var Comments = "";

    if (document.getElementById("Comments")) {
        Comments = document.getElementById("Comments").value;
    }

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/decline/'+token, {
            IdProvider: provider,
            Comments: Comments,     
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.location.href = '/administrador';
    }
)
.catch(error => {
    document.getElementById("Chg").style.display = "none";
    document.getElementById("BtnA").style.display = "inline-block";
    document.getElementById("BtnB").style.display = "inline-block";
})
    ;
}

function AdminProviderRevise() {
    Middleware();
    MiddlewareAdmin();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    var decode = "";

    decode = jwtDecode(token);

    var { provider } = useParams();

    var { rfc } = useParams();

    //Get documents
    const [documents, setDoduments] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/documents/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
            .then(response => {
                setDoduments(response.data);
            });
        }, []);
    
    //Get provider documents
    const [providerDocuments, setProviderDocuments] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/documents/' + provider +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setProviderDocuments(response.data);
        if (response.data == null) {
            setProviderDocuments([]);
        }
    });
    }, []);

    //Get provider general data
    const [data, setData] = React.useState([]);
    const [regimenCapital, setRegimenCapital] = React.useState([]);
    const [contribuyente, setContribuyente] = React.useState([]);
    const [regimenFiscal, setRegimenFiscal] = React.useState([]);
    const [actividadEconomica, setActividadEconomica] = React.useState([]);
    const [proveedor, setProveedor] = React.useState([]);
    const [tipoProveedor, setTipoProveedor] = React.useState([]);
    const [categoriaAbastoSuministro, setCategoriaAbastoSuministro] = React.useState([]);
    const [subcategoriaAbastoSuministro, setSubcategoriaAbastoSuministro] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/general-data/' + provider +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setData(response.data.GeneralData[0]);
        setRegimenCapital(response.data.RegimenCapital);
        setContribuyente(response.data.Contribuyente);
        setRegimenFiscal(response.data.RegimenFiscal);
        setActividadEconomica(response.data.ActividadEconomica);
        setProveedor(response.data.Proveedor);
        setTipoProveedor(response.data.GeneralData[0].TipoProveedor);
        setCategoriaAbastoSuministro(response.data.CategoriaAbastoSuministro);
        setSubcategoriaAbastoSuministro(response.data.SubcategoriaAbastoSuministro);
    });
    }, []);

    //Get provider general data
    const [answers, setAnswers] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/questionanaries/answers/' + rfc+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setAnswers(response.data);
        if (response.data == null) {
            setAnswers([]);
        }
    });
    }, []);

    ///api/provider/contacts/get/
    const [contacts, setContacts] = React.useState([]);
    const [contactos, setContactos] = React.useState([]);
    const [puesto, setPuesto] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/contacts/' + provider + '/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setContacts(response.data.Contacts);
        setContactos(response.data.Contacto);
        setPuesto(response.data.Puesto);
    });
    }, []);

    const [bankAccounts, setbankAccounts] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/bank-accounts/' + provider+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setbankAccounts(response.data);
    });
    }, []);

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Proveedor {rfc}</h1>
                        <br></br>
                        <div>
                            <p><i id="ChgB" className="fa fa-spinner fa-spin Chg"></i></p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Documentos</h3>
                        <br></br>
                        <br></br>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Tipo de documento</th>
                                    <th scope='col'>Documento</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    providerDocuments
                                    &&
                                    providerDocuments.map(item => (
                                        <tr id={"fileProvider"+item.tipoDocumento} key={item.tipoDocumento} value={"fileProvider"+item.tipoDocumento}>
                                            <td>
                                                {
                                                    documents.map(docs => (
                                                        item.tipoDocumento == docs.code
                                                        &&
                                                        docs.name
                                                    ))
                                                }
                                            </td>
                                            <td>{item.documento}</td>
                                            <td>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16" onClick={() => ProviderDocumentView(item.id)}>
                                                    <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                                </svg>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Datos generales</h3>
                        <br></br>
                        <br></br>
                        <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Registro Federal de Contribuyentes</label>
                                            <br></br>
                                            <input type="input" name="rfc" id="rfc" className="form-control Input-Style" value={rfc} disabled></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Denominación/Razón Social</label>
                                            <br></br>
                                            <input type="input" name="RazonSocial" id="RazonSocial" className="form-control Input-Style" value={data.RazonSocial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Régimen Capital</label>
                                            <select name="RegimenCapital" id="RegimenCapital" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenCapital} disabled>
                                                {
                                                    regimenCapital.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <br></br>
                                            
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Nombre Comercial</label>
                                            <br></br>
                                            <input type="input" name="NombreComercial" id="NombreComercial" className="form-control Input-Style" value={data.NombreComercial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div>
                                            <label>Tipo de Contribuyente</label>
                                            <br></br>
                                            <select name="TipoContribuyente" id="TipoContribuyente" aria-label="Default select example" className="form-select Input-Style" value={data.TipoContribuyente} disabled>
                                                {
                                                    contribuyente.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Régimen Fiscal</label>
                                            <br></br>
                                            <select name="RegimenFiscal" id="RegimenFiscal" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenFiscal} disabled>
                                                {
                                                    regimenFiscal.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Actividad Económica</label>
                                            <br></br>
                                            <select name="ActividadEconomica" id="ActividadEconomica" aria-label="Default select example" className="form-select Input-Style" value={data.ActividadEconomica} disabled>
                                                {
                                                    actividadEconomica.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div>
                                            <label>Régimen</label>
                                            <br></br>
                                            <input type="input" name="Regimen" id="Regimen" className="form-control Input-Style" value={data.Regimen} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col">
                                        <div>
                                            <label>Dirección Constancia Situación Fiscal</label>
                                            <br></br>
                                            <input type="input" name="DireccionFiscal" id="DireccionFiscal" className="form-control Input-Style" value={data.DireccionFiscal} disabled></input>
                                            <label></label>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Tipo Proveedor</label>
                                            <br></br>
                                            <select name="TipoProveedor" id="TipoProveedor" aria-label="Default select example" className="form-select Select-Style" disabled required>
                                                {
                                                    data.TipoProveedor == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    proveedor.map(item => (
                                                        item.Codigo == data.TipoProveedor
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    proveedor.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'></label><label>Registro REPSE</label>
                                            <br></br>
                                            <input type="input" name="RegistroREPSE" id="RegistroREPSE" className="form-control Input-Style" value={data.RegistroREPSE} disabled></input>
                                            <label></label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Categoria de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="CategoriaAbastoSuministro" id="CategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" value={data.CategoriaAbastoSuministro} disabled required>
                                                {
                                                    data.CategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    categoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.CategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    categoriaAbastoSuministro.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Sub Categoría de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="SubcategoriaAbastoSuministro" id="SubcategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" value={data.SubcategoriaAbastoSuministro} disabled required>
                                                <option value="">Selecciona...</option>
                                                {
                                                    data.SubcategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.SubcategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br>
                                </div>
                                <br></br>
                                <br></br>
                            </div>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Cuestionario</h3>
                        <br></br>
                        <br></br>
                        <div>
                            <div className='row'>
                                {
                                    answers
                                    &&
                                    answers.map((item) => (
                                        item.Cuestionario == 1 && item.Pregunta == 1
                                        && 
                                        <div className='col-lg-4'>
                                            <div className="question">
                                                <div>
                                                    <label>Ventas Anuales<span>*</span></label>
                                                    <br></br>
                                                    <select name="Cuestionario1Pregunta1" id="Cuestionario1Pregunta1" aria-label="Default select example" className="form-select" value={item.Respuesta} disabled>
                                                        <option value="">Selecciona...</option>
                                                        <option value="35">ENTRE 4,000,000 Y 100,000,000</option>
                                                        <option value="36">ENTRE 100,000,001 Y 250,000,000</option>
                                                        <option value="37">MAS DE 250,000,001</option>
                                                        <option value="38">MENOS DE 4,000,000</option>
                                                        <option value="39">NO DEFINIDO</option>
                                                    </select>
                                                </div>
                                                <br></br>
                                            </div>
                                        </div>
                                    ))
                                }
                                {
                                    answers
                                    &&
                                    answers.map((item) => (
                                        item.Cuestionario == 1 && item.Pregunta == 2
                                        && 
                                        <div className='col-lg-4'>
                                            <div className="question">
                                                <div>
                                                    <label>Número colaboradores<span>*</span></label>
                                                    <br></br>
                                                    <select name="Cuestionario1Pregunta2" id="Cuestionario1Pregunta2" aria-label="Default select example" className="form-select" value={item.Respuesta} disabled>
                                                    <option value="">Selecciona...</option>
                                                    <option value="40">DE 11 A 99</option>
                                                    <option value="41">100 A 249</option>
                                                    <option value="42">250 O MÁS</option>
                                                    <option value="43">NO DEFINIDO</option>
                                                    <option value="44">0 A 10</option>
                                                    </select>
                                                    <label><span></span></label>
                                                </div>
                                                <br></br>
                                            </div>
                                        </div>
                                    ))
                                }
                                {
                                    answers
                                    &&
                                    answers.map((item) => (
                                        item.Cuestionario == 1 && item.Pregunta == 3
                                        && 
                                        <div className='col-lg-4'>
                                            <div className="question">
                                                <div>
                                                    <label>Certificado CCMX<span>*</span></label>
                                                    <br></br>
                                                    <select name="Cuestionario1Pregunta3" id="Cuestionario1Pregunta3" aria-label="Default select example" className="form-select" value={item.Respuesta} disabled>
                                                    <option value="">Selecciona...</option>
                                                    <option value="45">SI</option>
                                                    <option value="46">NO</option>
                                                    </select>
                                                    <label><span></span></label>
                                                </div>
                                                <br></br>
                                            </div>
                                        </div>
                                    ))
                                }   
                            </div>
                            <div className='row'>
                                {
                                    answers
                                    &&
                                    answers.map((item) => (
                                        item.Cuestionario == 2 && item.Pregunta == 1
                                        && 
                                        <div className='col-lg-6'>
                                            <div className="question">
                                                <div>
                                                    <label>Selecciona el tamaño de la empresa:<span>*</span></label>
                                                    <br></br>
                                                    <select name="Cuestionario2Pregunta1" id="Cuestionario2Pregunta1" aria-label="Default select example" className="form-select" value={item.Respuesta} disabled>
                                                    <option value="">Selecciona...</option>
                                                    <option value="1">Microempresa (son todos aquellos negocios que tienen menos de 10 trabajadores, generan anualmente ventas hasta por 4 millones de pesos)</option>
                                                    <option value="2">Pequeña empresa (negocios que tiene entre 11 y 30 trabajadores o generan ventas anuales superiores a los 4 millones y hasta 100 millones de pesos)</option>
                                                    <option value="3">Mediana empresa (negocios dedicados que tiene desde 31 hasta 100 trabajadores, y generan anualmente ventas que van desde los 100 millones y pueden superar hasta 250 millones de pesos)</option>
                                                    <option value="4">Grande (empresas a aquellos negocios dedicados a los servicios y que tienen desde 101 hasta 251 trabajadores y tienen ventas superiores a los 250 millones de pesos)</option>
                                                    </select>
                                                    <label><span></span></label>
                                                </div>
                                                <br></br>
                                            </div>
                                        </div>
                                    ))
                                }
                                {
                                    answers
                                    &&
                                    answers.map((item) => (
                                        item.Cuestionario == 2 && item.Pregunta == 2
                                        && 
                                        <div className='col-lg-6'>
                                            <div className="question">
                                                <div>
                                                    <label>¿La empresa forma parte del Pacto Mundial de las Naciones Unidas?<span>*</span></label>
                                                    <br></br>
                                                    <select name="Cuestionario2Pregunta2" id="Cuestionario2Pregunta2" aria-label="Default select example" className="form-select" value={item.Respuesta} disabled>
                                                        <option value="">Selecciona...</option>
                                                        <option value="5">Si</option>
                                                        <option value="6">No</option>
                                                    </select>
                                                    <label><span></span></label>
                                                </div>
                                                <br></br>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <br></br>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="question text-left">
                                        <div className='Text-left'>¿Cuáles Objetivos de Desarrollo Sostenible está apoyando activamente su empresa? (marque todos los que apliquen)</div>
                                        <br></br>
                                        <div className='Text-left'>
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 7
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check1").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 8
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check2").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 9
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check3").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 10
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check4").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 11
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check5").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 12
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check6").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 13
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check7").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 14
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check8").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 15
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check9").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 16
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check10").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 17
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check11").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 18
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check12").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 19
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check13").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 20
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check14").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 21
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check15").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 22
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check16").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 23
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check17").checked = true)
                                                ))
                                            }
                                            {
                                                answers
                                                &&
                                                answers.map(item => (
                                                    item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 24
                                                    && 
                                                    (document.getElementById("Cuestionario2Pregunta3Check18").checked = true)
                                                ))
                                            }
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check1" id="Cuestionario2Pregunta3Check1" value="7" disabled></input>Fin de la pobreza</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check2" id="Cuestionario2Pregunta3Check2" value="8" disabled></input>Hambre cero</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check3" id="Cuestionario2Pregunta3Check3" value="9" disabled></input>Salud y bienestar</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check4" id="Cuestionario2Pregunta3Check4" value="10" disabled></input>Educación de calidad</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check5" id="Cuestionario2Pregunta3Check5" value="11" disabled></input>Igualdad de género</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check6" id="Cuestionario2Pregunta3Check6" value="12" disabled></input>Agua limpia y saneamiento</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check7" id="Cuestionario2Pregunta3Check7" value="13" disabled></input>Energía asequible y no contaminante</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check8" id="Cuestionario2Pregunta3Check8" value="14" disabled></input>Trabajo decente y crecimiento económico</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check9" id="Cuestionario2Pregunta3Check9" value="15" disabled></input>Industria, innovación e infraestructura</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check10" id="Cuestionario2Pregunta3Check10" value="16" disabled></input>Reducción de las desigualdades</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check11" id="Cuestionario2Pregunta3Check11" value="17" disabled></input>Ciudades y comunidades sostenibles</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check12" id="Cuestionario2Pregunta3Check12" value="18" disabled></input>Producción y consumo responsables</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check13" id="Cuestionario2Pregunta3Check13" value="19" disabled></input>Acción por el clima</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check14" id="Cuestionario2Pregunta3Check14" value="20" disabled></input>Vida submarina</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check15" id="Cuestionario2Pregunta3Check15" value="21" disabled></input>Vida de ecosistemas terrestres</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check16" id="Cuestionario2Pregunta3Check16" value="22" disabled></input>Paz, justicia e instituciones sólidas</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check17" id="Cuestionario2Pregunta3Check17" value="23" disabled></input>Alianzas para lograr los objetivos</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check18" id="Cuestionario2Pregunta3Check18" value="24" disabled></input>Ninguno</label><br></br></div>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                <div className="question">
                                    <div className='Text-left'>En Grupo Herdez tenemos un fuerte compromiso con la Diversidad y la Inclusión, por lo que buscamos activamente hacer negocios con representantes de las comunidades más vulnerables de nuestro entorno, por lo que le agradecemos responder las siguientes preguntas:</div>
                                    <br></br>
                                    <div className='Text-left'>Favor de indicar si la persona dueña de la empresa o con mayoría de acciones pertenece a uno o más de estos colectivos (marque todas las que apliquen):</div>
                                    <br></br>
                                    <div className='Text-left'>
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 25
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check1").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 26
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check2").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 27
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check3").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 28
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check4").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 29
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check5").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 29
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta4Check5Add").value = item.RespuestaAdicional)
                                            ))
                                        }
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check1" id="Cuestionario2Pregunta4Check1" value="25" disabled></input>Mujeres</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check2" id="Cuestionario2Pregunta4Check2" value="26" disabled></input>Personas con Discapacidad</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check3" id="Cuestionario2Pregunta4Check3" value="27" disabled></input>Población LGBT+</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check4" id="Cuestionario2Pregunta4Check4" value="28" disabled></input>Pueblos originarios o poblaciones indígenas</label><br></br></div>
                                        <div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check5" id="Cuestionario2Pregunta4Check5" value="29" disabled></input>Otro grupo minoritario o vulnerable en México (especifique)</label><br></br></div>
                                        <input type="text" className="form-control" name="Cuestionario2Pregunta4Check5Add" id="Cuestionario2Pregunta4Check5Add" disabled></input>
                                        </div>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="question Text-left">
                                    <div>
                                        <label>¿Qué porcentaje del total de colaboradores son mujeres?<span>*</span></label><br></br>
                                        <br></br>
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 5 && item.Respuesta == 30
                                                && 
                                                <input type="text" name="Cuestionario2Pregunta5" id="Cuestionario2Pregunta7" className="form-control" value={item.RespuestaAdicional} disabled></input>
                                            ))
                                        }
                                    </div>
                                </div>
                                <br></br>
                                <div className="question Text-left">
                                    <div></div>
                                    <div>¿Cuentan con alguna certificación sobre sustentabilidad? (seleccione los que apliquen):</div>
                                    <div></div>
                                    <div>
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 31
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta6Check1").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 32
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta6Check2").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 33
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta6Check3").checked = true)
                                            ))
                                        }
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 33
                                                && 
                                                (document.getElementById("Cuestionario2Pregunta6Check3Add").value = item.RespuestaAdicional)
                                            ))
                                        }
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check1" id="Cuestionario2Pregunta6Check1" value="31" disabled></input>Diversidad e Inclusión: NOM025, WEPs, EDGE</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check2" id="Cuestionario2Pregunta6Check2" value="32" disabled></input>Medio Ambiente: ISO 14001, 50001</label><br></br></div>
                                        <div>
                                        <div>
                                            <label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check3" id="Cuestionario2Pregunta6Check3" value="33" disabled></input>Otros (especifique)</label><br></br>
                                            <input type="text" className="form-control" name="Cuestionario2Pregunta6Check3Add" id="Cuestionario2Pregunta6Check3Add" disabled></input>
                                        </div>
                                        </div>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="question Text-left">
                                    <div>
                                        <label>¿Qué porcentaje de la utilidad invierte la empresa en programas de Ambiente, Sociedad y Gobierno (ASG)?<span>*</span></label>
                                        <br></br>
                                        <br></br>
                                        {
                                            answers
                                            &&
                                            answers.map(item => (
                                                item.Cuestionario == 2 && item.Pregunta == 7 && item.Respuesta == 34
                                                && 
                                                <input type="text" name="Cuestionario2Pregunta7" id="Cuestionario2Pregunta7" className="form-control" value={item.RespuestaAdicional} disabled></input>
                                            ))
                                        }
                                        <label><span></span></label>
                                    </div>
                                    <br></br>
                                </div>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Contactos</h3>
                        <br></br>
                        <br></br>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Tipo de contacto</th>
                                    <th scope='col'>Puesto</th>
                                    <th scope='col'>Teléfono</th>
                                    <th scope="col">Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    contacts 
                                    &&
                                    contacts.map(item => (
                                        <tr id={"TipoContacto"+item.TipoContacto} key={"TipoContacto"+item.TipoContacto} value={item.TipoContacto}>
                                            <td>
                                                {item.Nombres+" "+item.Apellidos}
                                            </td>
                                            <td>
                                                {
                                                    contactos.map(itemTC =>(
                                                        item.TipoContacto == itemTC.Codigo
                                                        &&
                                                        itemTC.Nombre
                                                    ))
                                                }
                                            </td>
                                            <td>
                                                {
                                                    puesto.map(itemTP => (
                                                        item.Puesto == itemTP.Codigo
                                                        &&
                                                        itemTP.Nombre
                                                    ))
                                                }
                                            </td>
                                            <td>{item.Telefono}</td>
                                            <td>{item.Email}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Cuentas bancarias</h3>
                        <br></br>
                        <br></br>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Cuenta bancaria</th>
                                    <th scope="col">Clabe</th>
                                    <th scope='col'>Referencia 1</th>
                                    <th scope='col'>Referencia 2</th>
                                    <th scope="col">Beneficiario</th>
                                    <th scope="col">Estatus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bankAccounts 
                                    &&
                                    bankAccounts.map(item => (
                                        <tr id={"bankAccount"+item.id} key={"bankAccount"+item.id} value={"bankAccount"+item.id}>
                                            <td>
                                                {item.bankAccount}
                                            </td>
                                            <td>
                                                {item.Clabe}
                                            </td>
                                            <td>
                                                {item.Reference1}
                                            </td>
                                            <td>{item.Reference2}</td>
                                            <td>{item.Beneficiary}</td>
                                            <td>
                                                <input type='hidden' id="ccb" value={item.ccb}></input>
                                                {
                                                    item.ccb == 0
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 1
                                                    ?
                                                    <label onClick={() => AdminProviderBankAccountCertPetition(item.id, provider, rfc)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-patch-exclamation-fill m-2" viewBox="0 0 16 16">
                                                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                                        </svg>
                                                        Iniciar certificación
                                                    </label>
                                                    :
                                                    item.ccb == 2
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 3
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 4
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 5
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-award-fill m-2" viewBox="0 0 16 16">
                                                            <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z"/>
                                                            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z"/>
                                                        </svg>
                                                        Cuenta certificada
                                                    </label>
                                                    :
                                                    item.ccb == 6
                                                    &&
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                                        </svg>
                                                        Cuenta no certificada {item.ccb}
                                                    </label> 
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                        <label>Comentarios en caso de ser rechazado</label>
                        <br></br>
                        <br></br>
                        <textarea id="Comments" className='w-100 Input-style'></textarea>
                        <br></br>
                        <input id="BtnA" type='submit' value="Aceptar" className='Button-Style m-2' onClick={() => AdminProviderAccept(provider)}></input>
                        <input id="BtnB" type='submit' value="Rechazar" className='Button-Style m-2' onClick={() =>AdminProviderDecline(provider, rfc)}></input>
                        <i id="Chg"className="fa fa-spinner fa-spin Chg"></i>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminProviderRevise;